WL.registerComponent('health-indicator', {
  health: { type: WL.Type.Float, default: 100 },
  playerDamageSFXObj: { type: WL.Type.Object },
  uiElementObj: {type: WL.Type.Object},
}, {
  init: function () {
    this.initialHealth = this.health;
    this.meshes = this.uiElementObj.children;
    this.meshes.sort((a, b) => a.name.localeCompare(b.name));
    this.damageSound = this.playerDamageSFXObj.getComponent('howler-audio-source');
  },

  updateHealth: function (health) {
    if(this.health > health) {
      this.damageSound.play();
    }
    this.health = health;
    if (this.health < 80) this.meshes[4].getComponent('mesh').active = false;
    if (this.health < 60) this.meshes[3].getComponent('mesh').active = false;
    if (this.health < 40) this.meshes[2].getComponent('mesh').active = false;
    if (this.health < 20) this.meshes[1].getComponent('mesh').active = false;
    if (this.health <= 0) this.meshes[0].getComponent('mesh').active = false;
    if (this.health > 80) {
      for (let i = 0; i < this.meshes.length; i++) {
        this.meshes[i].getComponent('mesh').active = true;
      }
    }
  },
});
